'use strict';

var $loader;

/**
 * @function
 * @description Shows an AJAX-loader on top of a given container
 * @param {Element} container The Element on top of which the AJAX-Loader will be shown
 */
var show = function (container) {
    var target = (!container || $(container).length === 0) ? $('body') : $(container);
    $loader = $loader || $('.loader');

    if ($loader.length === 0) {
        $loader = $('<div/>').addClass('loader')
            .append($('<div/>').addClass('loader-indicator'), $('<div/>').addClass('loader-bg'));
    }
    return $loader.appendTo(target).show();
};
/**
 * @function
 * @description Hides an AJAX-loader
 */
var hide = function () {
    if ($loader) {
        $loader.hide();
    }
};

const spinnerLoaderLayout = `
    <div class="ms-flex spinner-loader-container">
        <div class="spinner-loader">
            <div class="spinner-dot"></div>
            <div class="spinner-dot"></div>
            <div class="spinner-dot"></div>
            <div class="spinner-dot"></div>
            <div class="spinner-dot"></div>
            <div class="spinner-dot"></div>
            <div class="spinner-dot"></div>
            <div class="spinner-dot"></div>
            <div class="spinner-dot"></div>
            <div class="spinner-dot"></div>
            <div class="spinner-dot"></div>
            <div class="spinner-dot"></div>
        </div>
    </div>
`;
/**
 * @description Reusable spinner loader constructor that can be attached to any container.
 * Note that loaderInstance.show() method should be explicitly called to make loader markup visible.
 * @param $container
 * @constructor
 */
var SpinnerLoader = function($container) {
    this.$el = $(spinnerLoaderLayout);
    $container.append(this.$el);
};

SpinnerLoader.prototype = {
    show() {
        this.$el.addClass('spinner-loader-container--visible');
    },
    hide() {
        this.$el.removeClass('spinner-loader-container--visible');
    },
    remove() {
        this.$el.remove();
    }
};

exports.show = show;
exports.hide = hide;
exports.SpinnerLoader = SpinnerLoader;
